import type { BankAccount } from 'api/btlApplicationForm/types';
import { countries } from 'pages/BtlApplicationFormPage/common/Address/countries';
import type { BankDetailsFormValues } from './types';

export const defaultBankDetailsFormValues: BankDetailsFormValues = {
  accountDetails: {
    accountName: '',
    accountNumber: '',
    sortCode: '',
    bankName: '',
  },
  bankAddress: {
    isManual: false,
    postcode: '',
    selectedAddress: '',
    addressLine1: '',
    addressLine2: '',
    town: '',
    country: '',
  },
};

export function mapBankAccountToFormValues(bankAccount: BankAccount): BankDetailsFormValues {
  const address = bankAccount.bank?.address;
  const hasExistingAddress = Boolean(address?.addressLine1 && address?.postcode && address?.town && address?.country);

  return {
    accountDetails: {
      accountName: bankAccount.accountName ?? '',
      accountNumber: bankAccount.accountNumber ?? '',
      sortCode: bankAccount.sortCode ?? '',
      bankName: bankAccount.bank?.name ?? '',
    },
    bankAddress: {
      isManual: hasExistingAddress,
      postcode: address?.postcode ?? '',
      selectedAddress: '',
      addressLine1: address?.addressLine1 ?? '',
      addressLine2: address?.addressLine2 ?? '',
      town: address?.town ?? '',
      country: address?.country ?? '',
    },
  };
}

export function buildBankAddressPayload(bankAddress: BankDetailsFormValues['bankAddress']) {
  if (bankAddress.isManual) {
    const countryCode = countries[bankAddress.country?.toLowerCase()]?.code || '';
    return {
      addressLine1: bankAddress.addressLine1,
      addressLine2: bankAddress.addressLine2 || null,
      postcode: bankAddress.postcode,
      town: bankAddress.town,
      country: bankAddress.country,
      countryCode,
    };
  }

  const parsed = bankAddress.selectedAddress ? JSON.parse(bankAddress.selectedAddress) : {};
  const country = parsed.country || bankAddress.country || '';
  const town = parsed.townOrCity || parsed.town || bankAddress.town || '';

  return {
    addressLine1: parsed.addressLine1 || bankAddress.addressLine1,
    addressLine2: parsed.addressLine2 || bankAddress.addressLine2 || null,
    postcode: parsed.postcode || bankAddress.postcode,
    town,
    country,
    countryCode: countries[country.toLowerCase()]?.code || '',
  };
}
